<template>
  <v-container class="fill-height pb-0">
    <v-card class="e-cardPractica-inicio e-elevation--4 e-border--radius fill-height" style="width: 100%">
      <v-card-title :class="color" class="e-cardPractica-inicio-title pb-0 justify-center">
        <div class="">
          <img :src="image"  alt="Personaje leccion" class="pb-2"/>
        </div>
      </v-card-title>
      <v-card-text class="e-cardPractica-inicio-text px-4 align-start d-flex justify-end">
        <div class="py-4">
          <p class="p-normal mb-4 mt-2">{{ descripcion }}</p>
          <div class="px-4">
            <v-btn
            class="mt-3 elevation-0"
            block
            round
            large
            router-link
            :to="router"
            color="primary white--text">
              COMENZAR
            </v-btn>
          </div>
        </div>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
export default {
  name: 'PracticaSeparador',
  props: {
    image: {
      type: String,
      default: ''
    },
    color: {
      type: String,
      default: 'azul'
    },
    descripcion: {
      type: String,
      default: ''
    },
    router: {
      type: String,
      default: ''
    }
  }
}
</script>
